<template>
  <v-btn class="btn-add"
    dark
    :color="btnColor"
    @click="goToCreate"
  >
  {{label}}
  </v-btn>
</template>

<script>
import router from '@/router'

export default {
  props: [
    'routeName',
    'routeParamsValue',
    'label',
    'btnColor'
  ],
  computed: {
    routeNameValue: {
      get () {
        return this.routeName
      }
    }
  },
  methods: {
    goToCreate () {
      router.push({ name: this.routeNameValue, params: this.routeParamsValue })
    }
  }
}
</script>
<style>
  .btn-add{
    bottom: 15px;
  }
</style>
